import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './services/auth/authentication.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { VersionService } from './services/version/version.service';
import { APP_VERSION } from './version.constant';

@Component({ standalone: false, selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';

  private current_user: any;
  private user_name: string;

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    public authService: AuthenticationService,
    private readonly titleService: Title,
    private readonly versionService: VersionService,
  ) {
    const rawHash = window.location.hash;
    if (rawHash.startsWith('#') && !rawHash.startsWith('#/')) {
      const normalizedRoute = rawHash.slice(1);
      if (normalizedRoute.length > 0) {
        window.location.replace(`${window.location.origin}${window.location.pathname}#/${normalizedRoute}`);
      }
    }

    const lang = localStorage.getItem('selected_language');
    this.translate.setDefaultLang('es_ES');
    if (lang) {
      this.translate.use(lang);
    } else {
      this.translate.use('es_ES');
    }
    this.user_name = '';
    this.current_user = this.authService.getCurrentUser();
    if (this.current_user?.completeName) {
      this.user_name = this.current_user.completeName;
    }
  }

  ngOnInit() {
    const frontVersion = APP_VERSION?.frontend ?? 'Desconocido';
    this.versionService.getVersion().then((versionObject: string | { version?: string } | null) => {
      const version = typeof versionObject === 'object' ? versionObject?.version ?? 'Desconocido' : versionObject ?? 'Desconocido';
      this.titleService.setTitle(`SITE - ${version} (${frontVersion})`);
    });
  }

  logout() {
    this.authService.logout();
  }

  isLoggedIn() {
    if (this.authService.getCurrentUser()) {
      return true;
    }
    return false;
  }

  shouldShowMainLayout(): boolean {
    const currentPath = this.router.url.split('?')[0];
    const hiddenLayoutRoutes = ['/login', '/logout', '/version'];
    const isSsoRoute = currentPath.startsWith('/sso/');
    const shouldHideLayout = hiddenLayoutRoutes.includes(currentPath) || isSsoRoute;
    return this.authService.isLoggedIn && !shouldHideLayout;
  }

  onLoggedIn(data: any) {
    localStorage.setItem('current_user', JSON.stringify(data.data));
    localStorage.setItem('access_token', data.data['access_token']);
    this.current_user = this.authService.getCurrentUser();
    if (this.current_user?.completeName) {
      this.user_name = this.current_user.completeName;
    }
    this.router.navigate(['inicio']);
  }
}
